/**
 * CopyButton — Botão que copia texto pro clipboard com feedback visual
 */
import { useState } from 'preact/hooks';
import { T } from '../../styles/tokens';

interface CopyButtonProps {
  /** Texto a ser copiado */
  text: string;
  /** Label do botão (opcional) */
  label?: string;
  /** Tamanho do botão */
  size?: 'sm' | 'md';
}

export function CopyButton({ text, label, size = 'md' }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback pra browsers antigos
      const el = document.createElement('textarea');
      el.value = text;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const isSm = size === 'sm';

  return (
    <button
      onClick={handleCopy}
      title={copied ? 'Copiado!' : 'Copiar'}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: T.space1,
        padding: isSm ? `${T.space1}px ${T.space2}px` : `${T.space2}px ${T.space3}px`,
        borderRadius: T.radiusMd,
        border: `1px solid ${T.border}`,
        background: copied ? T.successBg : 'transparent',
        color: copied ? T.success : T.textSecondary,
        fontSize: isSm ? T.textXs : T.textSm,
        cursor: 'pointer',
        transition: `all ${T.transitionFast}`,
      }}
    >
      <span style={{ fontSize: isSm ? 12 : 14 }}>{copied ? '✓' : '📋'}</span>
      {label && <span>{copied ? 'Copiado!' : label}</span>}
    </button>
  );
}
